import {
  LIST_PROCESS_MASTER_DETAIL_PROCESS_REQUEST,
  LIST_PROCESS_MASTER_DETAIL_PROCESS_SUCCESS,
  LIST_PROCESS_MASTER_DETAIL_PROCESS_FAILURE,
  DETAIL_LIST_PROCESS_MASTER_DETAIL_PROCESS_REQUEST,
  DETAIL_LIST_PROCESS_MASTER_DETAIL_PROCESS_SUCCESS,
  DETAIL_LIST_PROCESS_MASTER_DETAIL_PROCESS_FAILURE,
  DETAIL_PROCESS_MASTER_DETAIL_PROCESS_REQUEST,
  DETAIL_PROCESS_MASTER_DETAIL_PROCESS_SUCCESS,
  DETAIL_PROCESS_MASTER_DETAIL_PROCESS_FAILURE,
  EXPORT_PROCESS_MASTER_DETAIL_PROCESS_REQUEST,
  EXPORT_PROCESS_MASTER_DETAIL_PROCESS_SUCCESS,
  EXPORT_PROCESS_MASTER_DETAIL_PROCESS_FAILURE
} from '../../constants/master-detail-process'

const initialState = {
  error: null,
  pageable: {
    page: 1,
    size: 10
  }
}

const masterDetailProcess = (state = initialState, action) => {
  const { keyNameLoading, keyNameData, payload, dummy } = action

  switch (action.type) {
    case LIST_PROCESS_MASTER_DETAIL_PROCESS_REQUEST:
      return {
        ...state,
        [keyNameLoading]: true
      }
    case LIST_PROCESS_MASTER_DETAIL_PROCESS_SUCCESS:
      return {
        ...state,
        [keyNameLoading]: false,
        [keyNameData]: payload,
        pageable: action.pageable,
        error: null
      }
    case LIST_PROCESS_MASTER_DETAIL_PROCESS_FAILURE:
      return {
        ...state,
        [keyNameLoading]: false,
        error: action.payload,
        [keyNameData]: dummy
      }
    case DETAIL_LIST_PROCESS_MASTER_DETAIL_PROCESS_REQUEST:
      return {
        ...state,
        [keyNameLoading]: true
      }
    case DETAIL_LIST_PROCESS_MASTER_DETAIL_PROCESS_SUCCESS:
      return {
        ...state,
        [keyNameLoading]: false,
        [keyNameData]: action.payload,
        pageable: action.pageable,
        error: null
      }
    case DETAIL_LIST_PROCESS_MASTER_DETAIL_PROCESS_FAILURE:
      return {
        ...state,
        [keyNameLoading]: false,
        error: action.payload,
        [keyNameData]: dummy
      }
    case DETAIL_PROCESS_MASTER_DETAIL_PROCESS_REQUEST:
      return {
        ...state,
        [keyNameLoading]: true
      }
    case DETAIL_PROCESS_MASTER_DETAIL_PROCESS_SUCCESS:
      return {
        ...state,
        [keyNameLoading]: false,
        [keyNameData]: action.payload,
        error: null
      }
    case DETAIL_PROCESS_MASTER_DETAIL_PROCESS_FAILURE:
      return {
        ...state,
        [keyNameLoading]: false,
        error: action.payload,
        [keyNameData]: dummy
      }
    case EXPORT_PROCESS_MASTER_DETAIL_PROCESS_REQUEST:
      return {
        ...state,
        [keyNameLoading]: true
      }
    case EXPORT_PROCESS_MASTER_DETAIL_PROCESS_SUCCESS:
      return {
        ...state,
        [keyNameLoading]: false,
        error: null
      }
    case EXPORT_PROCESS_MASTER_DETAIL_PROCESS_FAILURE:
      return {
        ...state,
        [keyNameLoading]: false,
        error: action.payload
      }
    case action?.typeCustomRequest:
      return {
        ...state,
        [keyNameLoading]: true
      }
    case action?.typeCustomSuccess:
      return {
        ...state,
        [keyNameLoading]: false,
        [keyNameData]: action.payload,
        ...(action.showPageable && { pageable: action.pageable }),
        error: null
      }
    case action?.typeCustomFailure:
      return {
        ...state,
        [keyNameLoading]: false,
        error: action.payload,
        [keyNameData]: dummy
      }
    default:
      return state
  }
}

export default masterDetailProcess
